import { AdminFetchBankOnboardings, AdminStartBankOnboarding } from 'src/constants/actionTypes'
import type { BankOnboarding, FetchBankOnboardingsPayload } from 'src/interfaces/bankOnboarding'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { Action } from 'src/utils/reduxUtils'
import type { BankOnboardingState } from './types'

const buildKey = (payload?: FetchBankOnboardingsPayload): string => {
  return `${payload?.search ?? ''}|${payload?.status ?? ''}`
}

const getInitialState = (): BankOnboardingState => {
  return {
    onboardings: [],
    loadedKey: null,
    requestedKey: null,
    loading: false,
    error: null,
    submitting: false,
  }
}

export const bankOnboardingReducer = (
  state: BankOnboardingState = getInitialState(),
  action: Action<unknown>,
): BankOnboardingState => {
  switch (action.type) {
    case AdminFetchBankOnboardings.type.REQUEST: {
      const requestedKey = buildKey(action.payload as FetchBankOnboardingsPayload | undefined)
      const isSameKey = requestedKey === state.loadedKey

      return {
        ...state,
        onboardings: isSameKey ? state.onboardings : [],
        loadedKey: isSameKey ? state.loadedKey : null,
        requestedKey,
        loading: true,
        error: null,
      }
    }
    case AdminFetchBankOnboardings.type.SUCCESS:
      return {
        ...state,
        onboardings: (action.payload as BankOnboarding[] | undefined) ?? [],
        loadedKey: state.requestedKey,
        loading: false,
        error: null,
      }
    case AdminFetchBankOnboardings.type.FAILED:
      return {
        ...state,
        loading: false,
        error: resolveErrorMessage(action.payload, 'Failed to load bank onboardings'),
      }

    case AdminStartBankOnboarding.type.REQUEST:
      return { ...state, submitting: true }
    case AdminStartBankOnboarding.type.SUCCESS:
    case AdminStartBankOnboarding.type.FAILED:
      return { ...state, submitting: false }

    default:
      return state
  }
}
